import b from 'b_';
//@ts-ignore
import Month, { Day } from 'calendar-month';
import { getMonth, getYear } from 'date-fns';
import { Chevrone } from 'education-icons';
import React from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import { SimpleCallback } from '../../../typings';
import { getDayStart, MONTH_NAMES } from '../utils';

import './datetimepicker__calendar.scss';

interface OwnProps {
    enabledDates?: Array<number>;
    month: number;
    year: number;
    now: Date;
    showPrevMonth: SimpleCallback;
    showNextMonth: SimpleCallback;
    selectDay: (day: Day) => SimpleCallback;
    selectedDate: Date;
}

interface HOCProps {
    intl: IntlShape;
}

interface Props extends HOCProps, OwnProps {}

const WEEK_DAYS_DIVIDER = ' ';
const notNextMonthFilter = (day: Day) => !day.next;

// TODO: компонент имеет много эдж кейсов, нужно написать для них тесты

export const DatetimepickerCalendar = ({
    enabledDates,
    year,
    month,
    now,
    intl,
    selectedDate,
    selectDay,
    showPrevMonth,
    showNextMonth,
}: Props) => {
    const weekDays = intl.formatMessage({ id: 'datepicker.weekDays' }).split(WEEK_DAYS_DIVIDER);
    const calendarMonth = new Month(year, month); // список дней для отображдения страницы календаря

    const currentMonth = getMonth(now);
    const currentYear = getYear(now);
    // сейчас датапикер не используется для выбора дат в прошлом
    const shouldDisablePrevMonthButton = month === currentMonth && currentYear === year;

    const todayTimestamp = getDayStart(now).getTime();
    const selectedDateTimeStamp = getDayStart(selectedDate).getTime();

    return (
        <div className="datetimepicker__calendar">
            <div className="datetimepicker__calendar-header">
                <div className="datetimepicker__month-title">
                    {MONTH_NAMES[month]} {year}
                </div>
                <div className="datetimepicker__calendar-controls">
                    <Chevrone
                        className={b('datetimepicker__calendar-control', {
                            hidden: year === 1 && month === 0,
                            direction: 'left',
                            disabled: shouldDisablePrevMonthButton,
                        })}
                        onClick={shouldDisablePrevMonthButton ? undefined : showPrevMonth}
                    />
                    <Chevrone
                        className={b('datetimepicker__calendar-control', {
                            hidden: year === 9999 && month === 11,
                            direction: 'right',
                        })}
                        onClick={showNextMonth}
                    />
                </div>
            </div>
            <div className="datetimepicker__calendar-days">
                <div className="datetimepicker__weekday-labels">
                    {weekDays.map((day: string, i: number) => (
                        <div className={b('datetimepicker__calendar-day', { 'day-label': true })} key={i}>
                            {day}
                        </div>
                    ))}
                </div>
                {calendarMonth.days.filter(notNextMonthFilter).map((day: any) => {
                    const calendarDayTimestamp = new Date(day.year, day.month, day.date).getTime();

                    const displayDate = month === day.month ? day.date : '';
                    const disabled = calendarDayTimestamp < todayTimestamp;

                    return (
                        <div
                            className={b('datetimepicker__calendar-day', {
                                'next-month': day.next,
                                'prev-month': day.previous,
                                passed: todayTimestamp > calendarDayTimestamp,
                                disabled: enabledDates && !enabledDates.includes(calendarDayTimestamp),
                                picked: selectedDateTimeStamp === calendarDayTimestamp,
                                'current-day': todayTimestamp === calendarDayTimestamp,
                            })}
                            key={`${day.date}:${day.month}:${day.year}`}
                            onClick={disabled ? undefined : selectDay(day)}
                        >
                            {displayDate}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default injectIntl(DatetimepickerCalendar);
